import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

const isProduction = process.env.NODE_ENV === "production";

function buildLedgerEntryQuery(entry) {
  if (!entry.clientId || !entry.entryKey) {
    throw new Error("clientledger production writes require clientId and entryKey.");
  }

  return `?clientId=${encodeURIComponent(entry.clientId)}&entryKey=${encodeURIComponent(entry.entryKey)}`;
}

async function getClientLedger(clientId = "") {
  const query = clientId ? `?clientId=${encodeURIComponent(clientId)}` : "";
  const response = await fetch(`${baseUrl}clientledger/${query}`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function saveClientLedgerEntry(entry, isNew = false) {
  const resourcePath = isProduction
    ? `clientledger/${!isNew && entry.id ? buildLedgerEntryQuery(entry) : ""}`
    : `clientledger/${encodeURIComponent(!isNew && entry.id ? entry.id : "")}`;

  const response = await fetch(`${baseUrl}${resourcePath}`, {
    method: !isNew && entry.id ? "PUT" : "POST",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(entry),
  });
  return handleResponse(response);
}

async function deleteClientLedgerEntry(entry) {
  const resourcePath = isProduction
    ? `clientledger/${buildLedgerEntryQuery(entry)}`
    : `clientledger/${encodeURIComponent(entry.id)}`;

  const response = await fetch(`${baseUrl}${resourcePath}`, {
    method: "DELETE",
    headers: authHeaders({ "content-type": "application/json" }),
  });
  return handleResponse(response);
}

export default { getClientLedger, saveClientLedgerEntry, deleteClientLedgerEntry };
